export const NO_WINNER = -1

export function calculateWinner(cells) {
  return NO_WINNER;
}
